import { Component, inject, input } from '@angular/core';

import { environment } from '../../../../environments/environment';

import { Medic } from '../../../shared/models/medic.model';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatDivider } from '@angular/material/list';
import { UiStore } from '../../../shared/state/ui.store';
import { MedicNavigare } from '../../../shared/services/medic-navigare.service';

@Component({
    selector: 'app-nav-medic',
    templateUrl: './nav-medic.component.html',
    styleUrls: ['./nav-medic.component.scss'],
    imports: [MatButton, MatMenuTrigger, MatMenu, MatMenuItem, MatDivider]
})
export class NavMedicComponent {
    private readonly medicNavigare = inject(MedicNavigare);
    private readonly uiStore = inject(UiStore);

    taxe = environment.taxeCmj;
    protected readonly currentUser = this.uiStore.user;

    readonly medic = input.required<Medic>();

    medicSelect(endpoint: string) {
        this.medicNavigare.sectiune(endpoint);
    }
}
